import React from 'react';

import { combineClassNames } from '@utils/combineClassNames';

const ModalTabHeader = ({ className, options, active, onChange }) => (
  <div
    className={combineClassNames(
      'tw-w-full !tw-mb-[-20px] tw-float-left',
      className
    )}
  >
    {options.map((option) => {
      const tabClassName = combineClassNames(
        'tw-px-4 tw-pb-3 tw-float-left tw-cursor-pointer tw-border-b-2 tw-border-transparent tw-border-solid tw-border-0',
        option.className || '',
        {
          '!tw-border-[var(--color-primary)] tw-border-b-4':
            option.value === active,
        }
      );

      return (
        <div
          key={option.value}
          className={tabClassName}
          onClick={() => onChange(option.value)}
        >
          {option.title}
          {option.count !== undefined ? (
            <small className="tw-ml-2">{option.count}</small>
          ) : null}
        </div>
      );
    })}
  </div>
);

export default ModalTabHeader;
